import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 3rem 1rem;
`;

export const RetryButton = styled.button`
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1.5rem;
  background: ${colors.GREEN};
  color: ${colors.WHITE};
  cursor: pointer;
`;
